import React from 'react';
import { Button, Tag } from 'antd';
import { getTagStatus } from '../../../lib/util/status';
import { Algorithm, Inference, Run, ClassificationResult } from '../../../types';
import { Icon } from '@ant-design/compatible';
import { CustomLink } from '../../../components/CustomLink';

const hasIssues = (annotations: Inference['annotations']) => {
  return annotations && annotations.result && annotations.result.hasIssues;
};

const hasMultiIssues = (run: Run) => {
  return run.hasUnreliableRecognition || !run.validationSuccess || !run.enrichmentSuccess;
};

export const getTableColumns = (
  onClickUrl: (inference: Inference) => any,
  onDelete: (e: any, inference: Inference) => any,
  algorithm: Algorithm | null
) => {
  return [
    {
      title: 'Name',
      key: 'fileName',
      dataIndex: 'fileName',
      render: (text: string, record: Inference) => (
        <span>
          <CustomLink
            disabled={record.run ? record.run.status === 'PROCESSING' : record.status === 'PROCESSING'}
            onClickUrl={onClickUrl(record)}
            style={{ padding: '4px' }}>
            {text}
          </CustomLink>
          {/* <Button
            type="link"
            style={{ color: '#1585FF', padding: '4px' }}
            onClick={() => onClick(record)}
            disabled={record.run ? record.run.status === 'PROCESSING' : record.status === 'PROCESSING'}>
            {text}
          </Button> */}
          {algorithm?.multiflow &&
            (record.inferenceResult?.result?.type as ClassificationResult[])?.map(el => (
              <Tag key={el.name} style={{ margin: '4px' }}>
                {el.name}
              </Tag>
            ))}
        </span>
      ),
    },
    algorithm
      ? {
          title: 'Valid',
          key: 'valid',
          dataIndex: 'valid',
          render: (text: string, record: Inference) => {
            return (
              <span>
                {(algorithm?.multiflow && record.run?.status === 'PROCESSING') ||
                (!algorithm?.multiflow && !record.annotations) ? (
                  <span />
                ) : (algorithm?.multiflow && record.run && hasMultiIssues(record.run)) ||
                  (!algorithm?.multiflow && hasIssues(record.annotations)) ? (
                  <Icon style={{ fontSize: 16 }} type="exclamation-circle" theme="twoTone" twoToneColor="#fa541c" />
                ) : (
                  <Icon style={{ fontSize: 16 }} type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                )}
              </span>
            );
          },
        }
      : {},
    {
      title: 'Status',
      key: 'id',
      dataIndex: 'id',
      render: (text: string, record: Inference) => (
        <span>{getTagStatus(record.run ? record.run.status : record.status)}</span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: Inference) => (
        <span>
          <Button type="link" style={{ fontSize: '14px' }} onClick={e => onDelete(e, record)}>
            Delete
          </Button>
        </span>
      ),
    },
  ];
};
